<section id="templates" class="templates section-auth">
    <div class="container">
        <div class="row">
            <div class="auth-wrapper">

                <!-- LEFT BRAND / HERO PANEL -->
                <aside class="auth-hero">
                    <!-- <div class="brand">
            <div class="brand-logo">AIO</div>
            <div class="brand-name">All-In-One Invoice</div>
          </div> -->

                    <h1 class="hero-heading">
                        Need to reset your password?
                    </h1>

                    <p class="hero-text">
                        It happens. Enter your email, and a secure password reset link will be emailed to you in a few
                        moments.
                    </p>

                    <div class="hero-highlight-card">
                        <!-- <div>
                            <div class="hero-metric">15k+</div>
                            <div class="hero-metric-label">
                                Invoices generated / month
                            </div>
                        </div> -->

                        <div class="hero-checklist">
                            <strong>Security first</strong>
                            <span>• Reset links expire after a short time for added safety.</span>
                            <span>• Passwords are stored using industry‑standard encryption.</span>
                        </div>
                    </div>
                </aside>

                <!-- RIGHT FORGOT PASSWORD PANEL -->
                <main class="auth-main">
                    <header class="auth-header">
                        <div class="auth-kicker">Forgot password</div>
                        <h2 class="auth-title">Reset your password</h2>
                        <p class="auth-subtitle">
                            Enter the email associated with your account and we’ll send you a link to create a new
                            password.
                        </p>
                    </header>

                    <form class="auth-form" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" autocomplete="off">
                        <div class="field-group">
                            <label class="field-label" for="email">
                                Email address <span>*</span>
                            </label>
                            <input class="form-control" type="email" id="email" formControlName="email"
                                placeholder="Enter you email*"
                                [class.is-invalid]="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched" />
                        </div>
                        <p class="auth-subtitle">
                            Make sure to check your spam folder if you don’t see the email within a few minutes.
                        </p>

                        <div class="auth-actions">
                            <button type="submit" class="btn btn-get-started w-100" [disabled]="forgotPasswordForm.invalid">
                                Send reset link
                            </button>
                        </div>
                    </form>

                    <div class="auth-footer">
                        Remember your password?
                        <a routerLink="/auth/login" class="link-accent">
                            Back to login
                        </a>
                    </div>
                </main>

            </div>
        </div>
    </div>
</section>